import type {
    GuildRankCardConfig,
    GuildRankEffects,
    GuildRankElementBase,
    GuildRankEmblemElement,
    GuildRankPlacaElement,
    GuildRankTextElement,
} from '../types';

export const DEFAULT_GUILDRANK_EFFECTS: GuildRankEffects = {
    enabled: true,
    rays: true,
    glow: true,
    crown: true,
    sparkles: true,
};

export const DEFAULT_GUILDRANK_CONFIG: GuildRankCardConfig = {
    cardMaxWidth: 280,
    highlightFirst: true,
    effects: { ...DEFAULT_GUILDRANK_EFFECTS },
    emblem: { enabled: true, left: 50, top: 33, width: 38 },
    rankBadge: { enabled: true, left: 50, top: 85, fontSize: 15 },
    placa: { enabled: true, left: 50, top: 46, width: 56 },
    name: { enabled: true, left: 50, top: 59, fontSize: 20, color: '#ffffff', letterSpacing: 2 },
    grade: { enabled: true, left: 50, top: 74, fontSize: 15, color: '#ffffff' },
    master: { enabled: true, left: 50, top: 78.5, fontSize: 14, color: '#ffd9a0' },
    exploits: { enabled: true, left: 50, top: 91.5, fontSize: 16, color: '#ffd700' },
};

export type GuildRankElementKey =
    | 'emblem'
    | 'rankBadge'
    | 'placa'
    | 'name'
    | 'grade'
    | 'master'
    | 'exploits';

type ElementConfig<T extends GuildRankElementKey> = GuildRankCardConfig[T];

function mergeEl<T extends { enabled: boolean; left: number; top: number }>(base: T, patch?: Partial<T>): T {
    return { ...base, ...patch };
}

export function mergeGuildRankConfig(cfg?: Partial<GuildRankCardConfig> | null): GuildRankCardConfig {
    return {
        cardMaxWidth: cfg?.cardMaxWidth ?? DEFAULT_GUILDRANK_CONFIG.cardMaxWidth,
        highlightFirst: cfg?.highlightFirst ?? DEFAULT_GUILDRANK_CONFIG.highlightFirst,
        effects: { ...DEFAULT_GUILDRANK_EFFECTS, ...cfg?.effects },
        emblem: mergeEl<GuildRankEmblemElement>(DEFAULT_GUILDRANK_CONFIG.emblem, cfg?.emblem),
        rankBadge: mergeEl<ElementConfig<'rankBadge'>>(DEFAULT_GUILDRANK_CONFIG.rankBadge, cfg?.rankBadge),
        placa: mergeEl<GuildRankPlacaElement>(DEFAULT_GUILDRANK_CONFIG.placa, cfg?.placa),
        name: mergeEl<GuildRankTextElement>(DEFAULT_GUILDRANK_CONFIG.name, cfg?.name),
        grade: mergeEl<GuildRankTextElement>(DEFAULT_GUILDRANK_CONFIG.grade, cfg?.grade),
        master: mergeEl<GuildRankTextElement>(DEFAULT_GUILDRANK_CONFIG.master, cfg?.master),
        exploits: mergeEl<GuildRankTextElement>(DEFAULT_GUILDRANK_CONFIG.exploits, cfg?.exploits),
    };
}

export function isGuildRankElementKey(key: string): key is GuildRankElementKey {
    return key === 'emblem' || key === 'rankBadge' || key === 'placa' ||
        key === 'name' || key === 'grade' || key === 'master' || key === 'exploits';
}

export type { GuildRankElementBase };